/* globals window */

import { EXTRA_MARGIN } from '../../utils/flyoutPositionHelper/flyoutPositionHelper';
export var MAX_WIDTH = 94; // % viewport width
export { EXTRA_MARGIN };
var minSideDistance = (100 - MAX_WIDTH) / 2;
var xCenter = function xCenter(parentPosition, childPosition) {
  return (parentPosition.right + parentPosition.left - childPosition.width) / 2;
};
var xSmartCenter = function xSmartCenter(parentPosition, childPosition) {
  var vw = window.innerWidth / 100; // vw, viewport width is 1% of the screen width

  var xNaiveCenter = xCenter(parentPosition, childPosition);
  return Math.max(minSideDistance * vw, xNaiveCenter) + Math.min((100 - minSideDistance) * vw - (childPosition.width + xNaiveCenter), 0);
};
var yCenter = function yCenter(parentPosition, childPosition) {
  return (parentPosition.bottom + parentPosition.top - childPosition.height) / 2;
};
var top = function top(parentPosition, childPosition) {
  return {
    x: xSmartCenter(parentPosition, childPosition),
    y: parentPosition.top - childPosition.height
  };
};
var bottom = function bottom(parentPosition, childPosition) {
  return {
    x: xSmartCenter(parentPosition, childPosition),
    y: parentPosition.bottom
  };
};
var left = function left(parentPosition, childPosition) {
  return {
    x: parentPosition.left - childPosition.width,
    y: yCenter(parentPosition, childPosition)
  };
};
var right = function right(parentPosition, childPosition) {
  return {
    x: parentPosition.right,
    y: yCenter(parentPosition, childPosition)
  };
};
var topLeft = function topLeft(parentPosition, childPosition) {
  return {
    x: parentPosition.left,
    y: parentPosition.top - childPosition.height
  };
};
var bottomLeft = function bottomLeft(parentPosition) {
  return {
    x: parentPosition.left,
    y: parentPosition.bottom
  };
};
var topRight = function topRight(parentPosition, childPosition) {
  return {
    x: parentPosition.right - childPosition.width,
    y: parentPosition.top - childPosition.height
  };
};
var bottomRight = function bottomRight(parentPosition, childPosition) {
  return {
    x: parentPosition.right - childPosition.width,
    y: parentPosition.bottom
  };
};
export default {
  top: top,
  bottom: bottom,
  left: left,
  right: right,
  topLeft: topLeft,
  bottomLeft: bottomLeft,
  topRight: topRight,
  bottomRight: bottomRight
};